import axios, { AxiosRequestConfig } from "axios";
import { IHttpClient } from "@/http/IHttpClient";
import { IHttpClientRequestParameters } from "@/http/IHttpClientRequestParameters";

const VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;

export class HttpClient implements IHttpClient {
  get<Request, Response>(
    parameters: IHttpClientRequestParameters<Request>
  ): Promise<Response> {
    return new Promise<Response>((resolve, reject) => {
      // extract the individual parameters
      const { url } = parameters;

      // axios request options like headers etc
      const options: AxiosRequestConfig = {
        headers: {},
      };

      // finally execute the GET request with axios:
      console.log("VUE_APP_BASE_URL: " + VUE_APP_BASE_URL);
      axios
        .get(VUE_APP_BASE_URL + url, options)
        .then((response: any) => {
          resolve(response.data as Response);
        })
        .catch((response: any) => {
          reject(response);
        });
    });
  }

  getUnauthenticated<Request, Response>(
    parameters: IHttpClientRequestParameters<Request>
  ): Promise<Response> {
    return new Promise<Response>((resolve, reject) => {
      // extract the individual parameters
      const { url } = parameters;

      // axios request options like headers etc
      const options: AxiosRequestConfig = {
        headers: {},
      };

      // finally execute the GET request with axios:
      axios
        .get(VUE_APP_BASE_URL + url, options)
        .then((response: any) => {
          resolve(response.data as Response);
        })
        .catch((response: any) => {
          reject(response);
        });
    });
  }

  postUnauthenticated<Request, Response>(
    parameters: IHttpClientRequestParameters<Request>
  ): Promise<Response> {
    return new Promise<Response>((resolve, reject) => {
      const { url, payload } = parameters;

      // finally execute the POST request with axios:

      console.log("VUE_APP_BASE_URL: " + VUE_APP_BASE_URL);
      axios
        .post(VUE_APP_BASE_URL + url, payload)
        .then((response: any) => {
          resolve(response.data as Response);
        })
        .catch((response: any) => {
          reject(response);
        });
    });
  }
}

export const httpClient = new HttpClient();
